var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopied(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "12px",
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4E6F796B-1981-47BF-8AB5-2E14E791DDDC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dropdown_Link-Copied",
    transform: "translate(-20.000000, -105.000000)",
    fill: "#177b57",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_ok_2014882_000000",
    transform: "translate(20.000000, 105.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1503966,0.320664601 L5.50688457,9.05238658 L1.80828947,5.94013894 C1.34561385,5.54902723 0.652311777,5.60252232 0.261200062,6.06449013 C-0.129911653,6.52716576 -0.0764165619,7.22046783 0.385551251,7.61157954 L4.84975927,11.3816674 C5.06302826,11.5595101 5.31243489,11.6303627 5.56113016,11.6303627 C5.84596306,11.6303627 6.13008459,11.5233796 6.34335359,11.3101035 L15.6800965,1.86629926 C16.1066345,1.43976127 16.1066345,0.745747833 15.6800965,0.319209848 C15.270916,-0.106634551 14.5769203,-0.106634551 14.1503646,0.320599155 L14.1503966,0.320664601 Z",
    id: "Path"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopied);
export default __webpack_public_path__ + "static/media/copied.d3236259b826756798ad214dade01d0a.svg";
export { ForwardRef as ReactComponent };